import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const isLogin = localStorage.getItem('token');
  if (isLogin) {
    return <Navigate to="/" />;
  }
  return children;
};

export default PublicRoute;
